// Funcion que devuelve si el simbolo va a la derecha o izquierda
export const isRightSymbol = (input: string, symbol: string): boolean => {
  // Encuentra la posición del símbolo en el string
  const symbolIndex = input.indexOf(symbol);

  // Comprueba si el símbolo está a la derecha
  if (symbolIndex > 0) {
    return true; // símbolo a la derecha
  } else {
    return false; // símbolo a la izquierda
  }
}